import { Component } from "react";
import AceEditor from "react-ace";

// LOAD-BEARING, AND THE ORDER IS TOO. An Ace theme has to be registered into Ace's module registry
// before an editor can select it, and a bare side-effect import is what registration is. Both are
// static because VirtualRenderer.setTheme falls back to config.loadModule() for an unregistered
// name — an async fetch that paints an UNTHEMED editor first, which is the flash this phase exists
// to remove. Do not "optimise" these into a dynamic import for the ~1.3 KB gzipped they cost.
//
// They must come AFTER the react-ace import: each theme file opens with a bare `ace.define(...)`
// against the `ace` global that ace-builds/src-noconflict/ace.js installs, and react-ace is what
// pulls that in. Reversed, this module throws ReferenceError at import time.
//
// This also closes a latent defect. Before this change 13 of the 22 call sites rendered
// theme="monokai" without importing it, and worked only because some other module in the bundle
// happened to have done so, or because ace-builds/webpack-resolver fetched it asynchronously.
import "ace-builds/src-noconflict/theme-github_light_default";
import "ace-builds/src-noconflict/theme-tomorrow_night";
import AceTheme from "context/aceTheme";
import { withTheme } from "context/theme";

/**
 * AceEditor bound to the site theme. Use this everywhere instead of react-ace's AceEditor.
 *
 * NOTHING HERE POKES THE EDITOR INSTANCE. react-ace's own componentDidUpdate compares the `theme`
 * prop and calls editor.setTheme() when it moves (react-ace 12.0.0, lib/ace.js:198-199), so making
 * this wrapper re-render IS the whole mechanism. Ace injects each theme's CSS once, keyed by its
 * cssClass, so both stylesheets coexist in the document and a switch is a container class swap plus
 * a re-measure — the editor is not remounted, and cursor, selection, scroll position and undo
 * history all survive it.
 *
 * `withTheme` (context/theme.js) is the app's existing subscribe-and-re-render HOC, the same one a
 * mermaid diagram or a vis-network canvas would use. It injects `theme` as "light" | "dark", which
 * collides by name with react-ace's own `theme` prop — so both injected props are consumed here and
 * neither is forwarded. A caller therefore CANNOT pin an editor to a fixed Ace theme by passing
 * `theme`; after this sweep none tries to, and `grep -r monokai src/` is what asserts that.
 * Everything else is forwarded untouched.
 */
export class Editor extends Component {
  render() {
    const { theme, themeChoice, ...rest } = this.props;
    return <AceEditor theme={AceTheme.name(theme)} {...rest} />;
  }
}

export default withTheme(Editor);
